import { ApiService } from './api.service';
import { StudentCompetencySummary } from '@/models/student/student-competency-summary';

class StudentCompetencySummaryService extends ApiService {
  constructor() {
    super();
  }

  getStudentCompetencySummary(studentID: number = 1): Promise<StudentCompetencySummary> {
    return this.get(StudentCompetencySummary, `students/${studentID}/competencySummary`, {});
  }
}

export const studentCompetencySummaryService = new StudentCompetencySummaryService();
